import { render } from "./PromptCardSelectCategory.vue?vue&type=template&id=654f4453&scoped=true"
import script from "./PromptCardSelectCategory.vue?vue&type=script&lang=js"
export * from "./PromptCardSelectCategory.vue?vue&type=script&lang=js"

import "./PromptCardSelectCategory.vue?vue&type=style&index=0&id=654f4453&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654f4453"]])

export default __exports__